import { erpAxios } from '.';

const getDjelatnostiKreditaHRH = async (level, id) => {
  const { data } = await erpAxios(`/gr-djelatnosti-kredita/hrh`, { params: { level: level, id: id } });
  return data;
};

export default getDjelatnostiKreditaHRH;
